import { Filters } from '@/app/types'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import React from 'react'

interface FilterButtonsProps {
	localValue: Filters
	handleReset: () => void
	applyFilters: () => void
	countActiveFilters: (filters: Filters) => number
}

const FilterButtons: React.FC<FilterButtonsProps> = ({
	localValue,
	handleReset,
	applyFilters,
	countActiveFilters,
}) => {
	const t = useTranslations('Keywords')
	return (
		<div className="hotel-list-filters__mobile-buttons gap-2">
			<div className="w-1/2 flex items-center">
				{countActiveFilters(localValue) > 0 && (
					<div
						onClick={handleReset}
						className={classNames(
							'py-2 rounded-full w-full bg-white text-score-good font-bold whitespace-nowrap'
						)}
					>
						{t('clearAll')}{' '}
						{countActiveFilters(localValue) > 0 &&
							`(${countActiveFilters(localValue)})`}
					</div>
				)}
			</div>
			<button
				onClick={applyFilters}
				className="!bg-gradient-to-r min-w-32 from-main to-[#E1004B] !rounded-full px-6 py-3 text-white font-bold whitespace-nowrap"
			>
				{t('showResults')}
			</button>
		</div>
	)
}

export default FilterButtons
